import { ComponentPermission, EComponentId } from "../Model/Permission";

class PermissionUtil {
  static canReadComponent(permissions: ComponentPermission[] | undefined, componentId: EComponentId | undefined) {
    const permission =
      permissions !== undefined && componentId !== undefined ? permissions.find((component) => component.componentId === componentId) : undefined;
    return permission ? permission.read : false;
  }

  static canWriteComponent(permissions: ComponentPermission[] | undefined, componentId: EComponentId | undefined) {
    const permission =
      permissions !== undefined && componentId !== undefined ? permissions.find((component) => component.componentId === componentId) : undefined;
    return permission ? permission.write : false;
  }

  static getFirstCanReadPermissionComponentId = (allPermissions: ComponentPermission[] | undefined, childIds: EComponentId[]) => {
    let childPermissionId = childIds[0];
    for (let i = 0; i < childIds.length; i++) {
      if (PermissionUtil.canReadComponent(allPermissions, childIds[i])) {
        childPermissionId = childIds[i];
        break;
      }
    }
  
    return childPermissionId;
  };
}

export default PermissionUtil;
